export default "__VITE_ASSET__c5e3c468__"